/*
 * otr-price.js — live product pricing for One Thousand Roads blog content
 * ----------------------------------------------------------------------
 * Replaces hardcoded prices in blog posts with the current price from Shopify.
 *
 * USAGE IN BLOG HTML:
 *   <span class="otr-price" data-handle="catalystspot-red-light-therapy-panel">$549.99</span>
 *
 * The text inside the span is the FALLBACK. It stays visible if this script
 * fails, is blocked, or the product lookup errors — so a reader never sees a
 * blank where a price should be. Keep it roughly accurate.
 *
 * BEHAVIOUR:
 *   normal        -> $1,299.99
 *   on sale       -> $1,499.99 (struck through) $1,299.99
 *   sold out      -> "Currently unavailable"
 *   lookup fails  -> fallback text is left untouched
 *
 * Product handles are the last part of the product URL, e.g.
 *   /products/catalystmax-red-light-therapy-panel
 */
(function () {
  'use strict';

  var SELECTOR = '.otr-price[data-handle]';
  var cache = {};

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function render(nodes, product) {
    nodes.forEach(function (node) {
      if (product.available === false) {
        node.textContent = 'Currently unavailable';
        return;
      }
      var onSale = product.compare_at_price && product.compare_at_price > product.price;
      if (onSale) {
        node.innerHTML =
          '<s style="opacity:.6;font-weight:400">' + formatMoney(product.compare_at_price) + '</s> ' +
          formatMoney(product.price);
      } else {
        node.textContent = formatMoney(product.price);
      }
    });
  }

  function hydrate(root) {
    var els = (root || document).querySelectorAll(SELECTOR);
    if (!els.length) return;

    // Group nodes by handle so each product is fetched once per page.
    var byHandle = {};
    Array.prototype.forEach.call(els, function (el) {
      if (el.getAttribute('data-otr-price-done')) return;
      el.setAttribute('data-otr-price-done', '1');
      var handle = el.getAttribute('data-handle');
      if (!handle) return;
      (byHandle[handle] = byHandle[handle] || []).push(el);
    });

    Object.keys(byHandle).forEach(function (handle) {
      var nodes = byHandle[handle];

      if (cache[handle]) {
        cache[handle].then(function (p) { if (p) render(nodes, p); });
        return;
      }

      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });

      cache[handle].then(function (p) { if (p) render(nodes, p); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrate(); });
  } else {
    hydrate();
  }

  // Expose for manual re-runs (e.g. content injected after load).
  window.otrPriceHydrate = hydrate;
})();
